const DEFAULT_STATS = [
  { value: "120+", label: "Golf Courses" },
  { value: "30+", label: "Destinations" },
  { value: "15K+", label: "Happy Golfers" },
  { value: "8", label: "Years of Excellence" },
];

export default function AboutStats({ fields = {} }) {
  const { stats = DEFAULT_STATS } = fields;

  return (
    <section className="bg-[#D4AF37] py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((s, i) => (
            <div key={i}>
              <p className="text-[#0B2421] font-bold text-4xl sm:text-5xl mb-1">
                {s.value}
              </p>
              <p className="text-[#0B2421]/70 text-sm font-semibold uppercase tracking-wide">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
